function helperStringUpperCase (str) {
  return str.toUpperCase()
}

module.exports = helperStringUpperCase



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/helperStringUpperCase.js
// module id = vaxK
// module chunks = 141